const buildReturnUrl = ({
  originUrl = '',
  returnUrl = '',
  queryParams = ''
}) => originUrl && returnUrl && `${originUrl}?returnUrl=${encodeURIComponent(returnUrl)}${queryParams}`;

export default buildReturnUrl;
